import get from 'lodash/get';
import parseSort from '../utils/queryString/parseSort';
import getStoreGuideId from '../utils/guideItem/getStoreGuideId';
import { types } from '../utils/guideItemTypes';
import mapCategoryResponse from './data/mapCategoryResponse';

export const FETCH_CATEGORY = 'FETCH_CATEGORY';

export function fetchCategoryEffect(
  storeGuideId,
  { guideId, attributes, itemToken = '' },
) {
  const transform = (resp) => ({
    content: mapCategoryResponse(resp.data, guideId),
  });

  const queryParams = {
    ...parseSort(attributes),
    itemToken,
  };

  return {
    type: FETCH_CATEGORY,
    api: {
      endpoint: ['browse', 'getItems'],
      args: [guideId, queryParams],
      transform,
    },
    meta: {
      contentId: storeGuideId,
    },
  };
}

export function fetchCategoryWithContextEffect(
  type,
  guideId,
  contextGuideId,
  isNPEnabled,
) {
  const transform = (resp) => ({
    content: mapCategoryResponse(resp.data, guideId),
  });

  return {
    type,
    api: {
      endpoint: ['browse', 'getItemsWithContext'],
      args: [guideId, contextGuideId],
      transform,
    },
    meta: {
      contentId: guideId,
      isNPEnabled,
    },
  };
}

export function customBrowseItemsTransform(resp, guideId) {
  const containerItems = get(resp, 'data.items[0].children', []);
  return {
    content: {
      guideId,
      type: types.container,
      containerItems,
    },
  };
}

// this is different from the regular browse items call
// to be used for categories which return landing carousel type response
export function getCustomBrowseItemsByGuideId(guideId, type) {
  const transform = (resp) => customBrowseItemsTransform(resp, guideId);

  return {
    type,
    api: {
      endpoint: ['browse', 'getItems'],
      args: [guideId],
      transform,
    },
    meta: {
      contentId: guideId,
    },
  };
}

export function fetchCategory(guideContext) {
  const storeGuideId = getStoreGuideId(
    guideContext.guideId,
    guideContext.attributes,
  );
  return fetchCategoryEffect(storeGuideId, guideContext);
}
